module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/heldidcard.05f5e067.jpg";